import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tsu-why-chooseus',
  templateUrl: './why-chooseus.component.html',
  styleUrls: ['./why-chooseus.component.scss']
})
export class WhyChooseusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
